import { useContext } from 'react';
import { TwilioContext } from '../utils/twilioContext';

export const useDoctorVoice = () => {
  const context = useContext(TwilioContext);

  const makeCall = (
    brand: string,
    number?: string | undefined | null,
    customerId?: string | undefined | null,
    customerName?: string | undefined | null,
    consult?: string | undefined | null,
  ) => {
    const cleanedNumber = number?.trim();

    context?.makeCall(brand, cleanedNumber, customerId, customerName, consult);
  };

  const sendDigits = (digit: string) => {
    context?.sendDigits(digit);
  };

  const hangup = () => {
    context?.hangup();
  };

  const setMute = (value: boolean) => {
    context?.setMute(value);
  };

  const answerCall = () => {
    context?.answerCall();
  };

  const rejectCall = () => {
    context?.rejectCall();
  };

  return {
    makeCall,
    inCall: context?.inCall ?? false,
    connected: context?.connected ?? false,
    answerCall,
    rejectCall,
    hangup,
    setMute,
    incomingCall: context?.incomingCall ?? null,
    mute: context?.mute ?? false,
    sendDigits,
  };
};
